export default __webpack_public_path__ + "static/media/red-round.c89f6de1.svg";